const API = process.env.REACT_APP_BACKEND_URL;

export const track = (event) => {
  const body = JSON.stringify({ event });
  if (navigator.sendBeacon) {
    navigator.sendBeacon(`${API}/api/track`, new Blob([body], { type: "application/json" }));
  } else {
    fetch(`${API}/api/track`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  }
};

// Any element with data-track="event-name" is counted on click.
export const initClickTracking = () => {
  const handler = (e) => {
    const el = e.target.closest("[data-track]");
    if (el) track(el.dataset.track);
  };
  document.addEventListener("click", handler);
  return () => document.removeEventListener("click", handler);
};
